import {Injectable, OnInit} from '@angular/core';
import {Http} from '@angular/http';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '../../node_modules/@angular/common/http';
import {environment} from '../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {ConfService} from './conf.service';
import {ApigatewayListenerService} from './apigateway-listener.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import {AppComponent} from './app.component';
import {Router} from '@angular/router';
import {WebsocketService} from './websocket.service';


@Injectable({
    providedIn: 'root'
})
export class KongService implements OnInit {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };
    httpOptionsForJwt = {
        headers: new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        })
    };
    file: any;
    servicedata: any;
    routehostdata: any;
    routepathdata: any;
    ratelimitingOrig: any;
    keyauthOrig: any;
    ipRestriction: any;
    cors: any;
    acl: any;
    datadog: any;
    gatewayUrl: any;
    gatewayFullUrl: string;
    routes: any;
    gatewayRoutes: any;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    partnerShortCode: string;

    settingsData: any;
    defaultGatewayURL: any;

    constructor(private _http: HttpClient,
                private webSocketService: WebsocketService,
                private confPost: ConfService) {
    }

    ngOnInit() {

    }

    getDefaultPlugins() {

        this.partner = localStorage.getItem('partner');
        const temp = this.partner.split('-');
        if (temp.length > 1) {
            this.partnerShortCode = temp[temp.length - 1];
        } else {
            this.partnerShortCode = localStorage.getItem('partner');
        }

        this.ratelimitingOrig = {
            'name': 'rate-limiting',
            'config': {'minute': 5},
            'protocols': ['http', 'https'],
            'enabled': true
        };

        this.keyauthOrig = {
            'config': {
                'key_names': [
                    'apikey'
                ],
                'key_in_body': false,
                'hide_credentials': false,
                'run_on_preflight': true,
            },
            'name': 'key-auth',
            'enabled': true
        };
        this.ipRestriction = {
            'name': 'ip-restriction',
            'enabled': false,
            'config': {
                'allow': ['127.0.0.1']
            }
        };
        this.cors = {
            'name': 'cors',
            'enabled': true,
            'config': {
                'methods': ['GET', 'PUT', 'POST', 'PATCH', 'DELETE', 'OPTIONS'],
                'exposed_headers': [],
                'max_age': 300,
                'headers': [],
                'origins': [
                    '*'
                ],
                'credentials': false,
                'preflight_continue': false
            }
        };
        this.acl = {
            'name': 'acl',
            'enabled': true,
            'config': {
                'allow': [this.partnerShortCode],
                'deny': null,
                'hide_groups_header': false
            }
        };

        this.datadog = {
            'name': 'datadog',
            'enabled': true,
            'config': {
                'host': '127.0.0.1',
                'port': 8125,
                'prefix': 'apiplatform'
            }
        };
    }

    getTargetPartnerSettingsData(partner, account, dbref) {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(partner, account, dbref).subscribe(response => {
                if (response && response['body'] && response['body'][0]) {
                    // this.settingsData = response['body'][0];
                    resolve({settingsData: response['body'][0]});
                } else {
                    reject('failed');
                }
            }, error => {
                reject(error);
            });
        });
    }

    async getTargetPartnerDefaultGatewayURL(partner, account, dbref) {

        let defaultGatewayURL = partner + '.gateway.apiplatform.io';

        await this.getTargetPartnerSettingsData(partner, account, dbref).then(response => {
            if (response && response.hasOwnProperty('settingsData')) {
                const settingsData = response['settingsData'];
                const currentEnvironment = settingsData.environments.filter((env) => env['name'] === localStorage.getItem('partner'));
                if (currentEnvironment && currentEnvironment.length > 0) {
                    const apigatewayService = currentEnvironment[0]['services'].filter((service) => service['type'] === 'apigateway');
                    if (apigatewayService && apigatewayService.length > 0) {
                        const defaultGateway = apigatewayService[0]['configurations'].filter((config) => config['is_default'] === true);
                        if (defaultGateway && defaultGateway.length > 0) {
                            defaultGatewayURL = defaultGateway[0]['url'][0];
                        }
                    }
                }
            }
        });

        return defaultGatewayURL;
    }

    getSettingsData(partner, account, dbref) {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(partner, account, dbref).subscribe(response => {
                if (response && response['body'] && response['body'][0]) {
                    this.settingsData = response['body'][0];
                    resolve('success');
                } else {
                    reject('failed');
                }
            }, error => {
                reject(error);
            });
        });
    }

    async getDefaultGatewayURL() {
        if (this.defaultGatewayURL && this.defaultGatewayURL !== '') {
            return this.defaultGatewayURL;
        } else {

            this.defaultGatewayURL = localStorage.getItem('partner') + '.gateway.apiplatform.io';

            if (!this.settingsData) {
                await this.getSettingsData(localStorage.getItem('partner'), localStorage.getItem('account'), false);
            }
            if (this.settingsData) {
                if (this.settingsData.hasOwnProperty('body')) {
                    this.settingsData = this.settingsData['body'][0];
                }
                const currentEnvironment = this.settingsData.environments.filter((env) => env['name'] === localStorage.getItem('partner'));
                if (currentEnvironment && currentEnvironment.length > 0) {
                    const apigatewayService = currentEnvironment[0]['services'].filter((service) => service['type'] === 'apigateway');
                    if (apigatewayService && apigatewayService.length > 0) {
                        const defaultGateway = apigatewayService[0]['configurations'].filter((config) => config['is_default'] === true);
                        if (defaultGateway && defaultGateway.length > 0) {
                            this.defaultGatewayURL = defaultGateway[0]['url'][0];
                        }
                    }
                }
            }
            return this.defaultGatewayURL;
        }
    }

    enableDisablePluginForService(partner, account_id, entityName, version, pluginName, enable) {

        this.getServicesFromApiGatewayByNameOrId(partner + '-' + account_id + '-' + entityName).subscribe(service => {
            const gatewayService = service;
            this.getPluginsForServiceByPluginNameInApiGateway(gatewayService['name'], pluginName).subscribe(plugin => {
                const pluginData = plugin;
                const payload = {
                    'enable': enable
                };
                this.updatePluginInApiGateway(pluginData['id'], payload).subscribe(update => {
                });
            });
        });
    }

    publishEventMessage(apiName, version, title, message, timeStamp, action) {
        //this.websocketService.sendMessage('Hello From crud');
        const data = {
            partner: localStorage.getItem('partner'),
            account: localStorage.getItem('account'),
            apiName: apiName,
            apiVersion: version,
            title: title,
            action: action,
            user: localStorage.getItem('signInEmail'),
            createdDate: Date.now(),
            message: message,
            session: localStorage.getItem('sessionID'),
            timeStamp: timeStamp
        };
        this.webSocketService.sendApiMessage(data, localStorage.getItem('partner'), localStorage.getItem('account'), timeStamp, localStorage.getItem('sessionID'));
    }

    async  configureApiGateway(partner, account_id, entityName, version) {
        // this.gatewayUrl = (partner === account ? 'gateway.' + partner + '.apiplatform.io' : 'gateway.' + partner + '.' + account + '.apiplatform.io');
        this.gatewayUrl = await this.getTargetPartnerDefaultGatewayURL(partner, account_id, false);
        this.gatewayFullUrl = 'https://' + this.gatewayUrl;
        this.routehostdata = {
            'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'host',
            'protocols': ['http', 'https'],
            'hosts': [this.gatewayUrl],
            // 'hosts': [this.partner + '-' + this.account + '-' + this.entityName + '-host'],
        };
        this.routepathdata = {
            'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'path',
            'protocols': ['http', 'https'],
            'hosts': [this.gatewayUrl],
            'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName]
        };
        // this.ratelimitingOrig = {
        //     'name': 'rate-limiting',
        //     'config': {'minute': 5},
        //     'protocols': ['http', 'https'],
        //     'enabled': true
        // };
        //
        // this.keyauthOrig = {
        //     'name': 'key-auth'
        // };
        // this.ipRestriction = {
        //     'name': 'ip-restriction',
        //     'enabled': false,
        //     'config': {
        //         'whitelist': ['127.0.0.1']
        //     }
        // };
        // this.cors = {
        //     'name': 'cors',
        //     'enabled': true,
        //     'config': {
        //         'methods': [],
        //         'exposed_headers': [],
        //         'max_age': 300,
        //         'headers': [],
        //         'origins': [
        //             '*'
        //         ],
        //         'credentials': false,
        //         'preflight_continue': false
        //     }
        // };
        this.getDefaultPlugins();
        this.servicedata = {
            'name': partner + '-' + account_id + '-' + entityName + '-' + version,
            'retries': 5,
            'protocol': 'https',
            'host': environment.apihostname,
            'port': 443,
            'path': '/' + ((typeof version) === 'object' ? version['name'] : version) + '/data/' + partner + '/' + account_id + '/' + entityName,
            'connect_timeout': 60000,
            'write_timeout': 60000,
            'read_timeout': 60000
        };
        this.createServiceToApiGateway(this.servicedata).subscribe(res => {
            this.createRouteForAServiceToApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.routepathdata).subscribe(route => {
                this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ratelimitingOrig).subscribe(ratelimitingplugin => {
                    this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.keyauthOrig).subscribe(keyauthplugin => {
                        this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ipRestriction).subscribe(iprestriction => {
                            this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.cors).subscribe(cors => {
                                this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.acl).subscribe(acl => {
                                    this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.ratelimitingOrig).subscribe(ratelimiting1 => {
                                        this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.keyauthOrig).subscribe(keyauth1 => {
                                            this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.cors).subscribe(cors1 => {
                                                this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.ipRestriction).subscribe(iprestriction1 => {
                                                    this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.acl).subscribe(acl1 => {
                                                    }, error => {
                                                    });
                                                }, error => {
                                                });
                                            }, error => {
                                            });
                                        }, error => {
                                        });
                                    }, error => {
                                    });
                                }, error => {
                                });
                            }, error => {
                            });
                        }, error => {
                        });
                    }, error => {
                    });
                }, error => {
                });
            }, error => {
            });
        }, error => {
        });
    }

    async configureApiGatewayWithIpRestriction(partner, account_id, entityName, version, ipRestriction, isExecutor) {
        // this.gatewayUrl = (partner === account ? 'gateway.' + partner + '.apiplatform.io' : 'gateway.' + partner + '.' + account + '.apiplatform.io');
        this.gatewayUrl = await this.getTargetPartnerDefaultGatewayURL(partner, account_id, false);
        this.gatewayFullUrl = 'https://' + this.gatewayUrl;
        this.routehostdata = {
            'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'host',
            'protocols': ['http', 'https'],
            'hosts': [this.gatewayUrl],
            // 'hosts': [this.partner + '-' + this.account + '-' + this.entityName + '-host'],
        };
        this.routepathdata = {
            'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'path',
            'protocols': ['http', 'https'],
            'hosts': [this.gatewayUrl],
            'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName]
        };
        //
        this.getDefaultPlugins();
        var url = '/' + ((typeof version) === 'object' ? version['name'] : version) + '/data/' + partner + '/' + account_id + '/' + entityName;
        if (isExecutor) {
            url = '/' + partner + '/' + account_id + '/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName;
        }
        this.servicedata = {
            'name': partner + '-' + account_id + '-' + entityName + '-' + version,
            'retries': 5,
            'protocol': 'https',
            'host': environment.apihostname,
            'port': 443,
            'path': url,
            'connect_timeout': 60000,
            'write_timeout': 60000,
            'read_timeout': 60000
        };
        this.createServiceToApiGateway(this.servicedata).subscribe(res => {
            this.createRouteForAServiceToApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.routepathdata).subscribe(route => {
                this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ratelimitingOrig).subscribe(ratelimitingplugin => {
                    this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.keyauthOrig).subscribe(keyauthplugin => {
                        this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ipRestriction).subscribe(iprestriction => {
                            this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.cors).subscribe(cors => {
                                this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.acl).subscribe(acl => {
                                    this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.ratelimitingOrig).subscribe(ratelimiting1 => {
                                        this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.keyauthOrig).subscribe(keyauth1 => {
                                            this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.cors).subscribe(cors1 => {
                                                this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.ipRestriction).subscribe(iprestriction1 => {
                                                    this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.acl).subscribe(acl1 => {
                                                    }, error => {});
                                                }, error => {});
                                            }, error => {});
                                        }, error => {});
                                    }, error => {});
                                }, error => {});
                            }, error => {});
                        }, error => {});
                    }, error => {});
                }, error => {});
            }, error => {});
        }, error => {});
    }

    constructKeyValueGatewayConfigurations(configuredGatewaySettings) {
        const gatewaySettings = [];
        for (const plugin of configuredGatewaySettings) {
            if (plugin) {
                const gatewaySetting = {
                    config: {}
                };
                if (plugin['name'] === 'rate-limiting') {
                    gatewaySetting['protocols'] = ['http', 'https'];
                }
                gatewaySetting['name'] = plugin['name'];
                gatewaySetting['enabled'] = plugin['enabled'];
                gatewaySetting['config'] = plugin['config'];
                gatewaySettings.push(gatewaySetting);
            }
        }
        return gatewaySettings;
    }

    createPluginForRoute(partner, account_id, entityName, version, method, plugin, logTimeStamp, action) {
        this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
            info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> to route for <b>' + method + '</b> method',
            type: 'initial',
            icon: 'fa fa-shield'
        }, logTimeStamp, action);
        return new Promise((resolve, reject) => {
            this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-' + method, plugin).subscribe(response2 => {
                this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                    info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> to route for <b>' + method + '</b> method',
                    type: 'success',
                    icon: 'fa fa-shield'
                }, logTimeStamp, action);
                resolve('success');
            }, error => {
                this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                    info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> to route for <b>' + method + '</b> method',
                    type: 'error',
                    description: error.message
                }, logTimeStamp, action);
                resolve('failed');
            });
        });
    }

    createRouteForService(partner, account_id, entityName, version, routepathData, logTimeStamp, action) {
        let title = '';
        if (action === 'redeploy') {
            title = 'API REDEPLOYMENT';
        } else {
            title = 'API DEPLOYMENT';
        }
        return new Promise((resolve, reject) => {
            this.publishEventMessage(entityName, version, title, {
                info: 'Deploying route for <b>' + routepathData['methods'][0] + '</b> method: ' + routepathData['name'],
                type: 'initial',
                icon: 'fa fa-cloud-upload'
            },  logTimeStamp, action);
            this.createRouteForAServiceToApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, routepathData).subscribe(async response => {
                this.publishEventMessage(entityName, version, title, {
                    info: 'Deploying route for <b>' + routepathData['methods'][0] + '</b> method: ' + routepathData['name'],
                    type: 'success',
                    icon: 'fa fa-cloud-upload'
                }, logTimeStamp, action);
                resolve('success');
            }, error => {
                this.publishEventMessage(entityName, version, title, {
                    info: 'Deploying route for <b>' + routepathData['methods'][0] + '</b> method: ' + routepathData['name'],
                    type: 'error',
                    icon: 'fa fa-cloud-upload'
                }, logTimeStamp, action);
                resolve('failed');
            });
        });
    }

    updateExistingRoutes(partner, account_id, entityName, version, gatewayRoutes, routePlugins, isFromGatewayManagment, timeStamp, action) {
        return new Promise(async (resolve, reject) => {
            this.gatewayUrl = await this.getTargetPartnerDefaultGatewayURL(partner, account_id, false);
            let methods = [];
            if (gatewayRoutes[0]['methods'] === null || gatewayRoutes[0]['methods'] === undefined || gatewayRoutes[0]['methods'] === []) {
                methods = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
            } else {
                methods = gatewayRoutes[0]['methods'];
            }
            if ((methods.filter(element => element === 'OPTIONS')).length === 0) {
                methods.push('OPTIONS');
            }
            if (gatewayRoutes) {
                let routesCount = 0;
                gatewayRoutes.forEach(route => {
                    Promise.resolve(this.removePluginsFromRoute(route)).then(response1 => {
                        this.deleteRouteFromApiGatewayByNameOrId(route['id']).subscribe(async resp => {
                            routesCount += 1;
                            if (routesCount === gatewayRoutes.length) {
                                for (let i = 0; i < methods.length; i++) {
                                    const method = methods[i];
                                    if (method && method !== '') {
                                        this.routepathdata = {
                                            'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + method,
                                            'protocols': ['http', 'https'],
                                            'hosts': [this.gatewayUrl],
                                            'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName],
                                            'methods': [method]
                                        };
                                        await this.createRouteForService(partner, account_id, entityName, version, this.routepathdata, timeStamp, action);
                                        const pluginConfigs = this.constructKeyValueGatewayConfigurations(routePlugins);
                                        for (const plugin of pluginConfigs) {
                                            if (plugin) {
                                                await this.createPluginForRoute(partner, account_id, entityName, version, method, plugin, timeStamp, action);
                                            }
                                        }
                                    }
                                    if (i === methods.length - 1) {
                                        if (isFromGatewayManagment) {
                                            location.reload();
                                        }
                                        resolve('success');
                                    }
                                }
                                resolve('success');
                            }
                        }, error => {
                            reject(error);
                        });
                    }, error => {
                        reject(error);
                    });
                });
            } else {
                resolve('success');
            }
        });
    }

    // updateRouteWithMethods(partner, account_id, entityName, version, methods) {
    //     methods.push('OPTIONS');
    //     this.gatewayUrl = (partner === account_id ? partner + '.gateway.apiplatform.io' : partner + '.' + account_id + '.gateway.apiplatform.io');
    //     this.gatewayFullUrl = 'https://' + this.gatewayUrl;
    //     this.routepathdata = {
    //         // 'name': partner + '-' + account + '-' + entityName + '-' + version + '-' + 'path',
    //         'protocols': ['http', 'https'],
    //         'hosts': [this.gatewayUrl],
    //         'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName],
    //         'methods': methods
    //     };
    //
    //     this.getRoutesForAServiceFromApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version).toPromise().then(routes => {
    //         this.gatewayRoutes = routes;
    //         this.routes = this.gatewayRoutes.data;
    //         if (this.routes && this.routes.length !== 0) {
    //             const pathRouteId = this.routes[0].id;
    //             this.patchRouteInApiGateway(pathRouteId, this.routepathdata).subscribe(route => {
    //             });
    //         } else {
    //             this.routepathdata = {
    //                 'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'path',
    //                 'protocols': ['http', 'https'],
    //                 'hosts': [this.gatewayUrl],
    //                 'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName],
    //                 'methods': methods
    //             };
    //             this.createRouteForAServiceToApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.routepathdata).subscribe(route => {
    //             });
    //         }
    //     });
    // }

    deleteRouteByNameOrId(idOrName) {
        return new Promise((resolve, reject) => {
            this.deleteRouteFromApiGatewayByNameOrId(idOrName).subscribe(response => {
                resolve('success');
            }, error => {
                reject('failed');
            });
        });
    }

    updateDelta(partner, account_id, entityName, version, routes, deltaMethods, newMethods, timeStamp, action) {
        return new Promise(async (resolve, reject) => {
            const alreadyExistingMethods = [];
            let title = '';
            if (action === 'redeploy') {
                title = 'API REDEPLOYMENT';
            } else {
                title = 'API DEPLOYMENT';
            }
            this.publishEventMessage(entityName, version, title, {
                info: 'Deleting old route configurations',
                type: 'initial',
                icon: 'fa fa-shield'
            }, timeStamp, action);
            for (let i = 0; i < routes.length; i++) {
                if (routes[i]) {
                    const temp = routes[i]['name'].split('-');
                    alreadyExistingMethods.push(temp[temp.length - 1]);
                    for (let j = 0; j < deltaMethods.length; j++) {
                        if (temp[temp.length - 1] === deltaMethods[j]) {
                            await Promise.resolve(this.removePluginsFromRoute(routes[i])).then(async response1 => {
                                await this.deleteRouteByNameOrId(routes[i]['id']);
                            });
                        }
                    }
                }
            }
            this.publishEventMessage(entityName, version, title, {
                info: 'Deleting old route configurations',
                type: 'success',
                icon: 'fa fa-shield'
            }, timeStamp, action);
            const remainingMethodsForWhichRoutesToBeCreated = newMethods.filter(x => alreadyExistingMethods.indexOf(x) === -1);

            if (deltaMethods.includes('POST') === true) {
                this.getRouteFromApiGatewayByNameOrId(partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'OPTIONS').subscribe(response => {
                    if (response) {
                        this.patchRouteInApiGateway(response['id'], {methods: ['OPTIONS', 'POST']}).subscribe(resp => {});
                    }
                });
            }

            if (remainingMethodsForWhichRoutesToBeCreated.includes('POST') === true) {
                this.getRouteFromApiGatewayByNameOrId(partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'OPTIONS').subscribe(response => {
                    if (response) {
                        this.patchRouteInApiGateway(response['id'], {methods: ['OPTIONS']}).subscribe(resp => {});
                    }
                });
            }
            await this.createEachRouteForMethods(partner, account_id, entityName, version, remainingMethodsForWhichRoutesToBeCreated, timeStamp, action);
            resolve('success');
        });
    }


    updateRouteWithMethods(partner, account_id, entityName, version, methods, timeStamp, action) {
        return new Promise(async (resolve, reject) => {
            methods.push('OPTIONS');
            const allMethods = ['GET', 'PUT', 'POST', 'DELETE', 'PATCH', 'OPTIONS'];
            const deltaMethods = allMethods.filter(x => methods.indexOf(x) === -1);
            this.gatewayUrl = await this.getTargetPartnerDefaultGatewayURL(partner, account_id, false);
            this.gatewayFullUrl = 'https://' + this.gatewayUrl;
            this.getRoutesForAServiceFromApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version).subscribe(async routes => {
                this.gatewayRoutes = routes;
                this.routes = this.gatewayRoutes.data;
                if (this.routes && this.routes.length !== 0) {
                    let isRoutesOldDesign = false;
                    for (const route of this.routes) {
                        const routeNameParts = route['name'].split('-');
                        if (route['methods'] === null || route['methods'] === undefined || (route['methods'] && (route['methods'].length === 0 || (routeNameParts[routeNameParts.length - 1] !== 'OPTIONS' && route['methods'].length > 1)))) {
                            isRoutesOldDesign = true;
                            break;
                        }
                    }
                    if (isRoutesOldDesign === true) {
                        this.getPluginsForRouteInApiGateway(this.gatewayRoutes['data'][0]['name']).subscribe(async plugins => {
                            // await this.updateExistingRoutes(partner, account_id, entityName, version, this.gatewayRoutes['data'], plugins['data'], false);
                            let routesCount = 0;
                            this.gatewayRoutes['data'].forEach(async route => {
                                await this.removePluginsFromRoute(route);
                                await this.deleteRouteByNameOrId(route['id']);
                                routesCount += 1;
                                if (routesCount === this.gatewayRoutes['data'].length) {
                                    this.getRoutesForAServiceFromApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version).toPromise().then(async routeResp => {
                                        this.gatewayRoutes = routeResp;
                                        this.routes = this.gatewayRoutes.data;
                                        await this.updateDelta(partner, account_id, entityName, version, routes['data'], deltaMethods, methods, timeStamp, action);
                                        resolve('success');
                                    }, error => {
                                        resolve('success');
                                    });
                                } else {
                                    resolve('success');
                                }
                            });
                            if (this.gatewayRoutes['data'].length === 0) {
                                resolve('success');
                            }
                        }, error => {
                            resolve('success');
                        });
                    } else {
                        await this.updateDelta(partner, account_id, entityName, version, routes['data'], deltaMethods, methods, timeStamp, action);
                        resolve('success');
                    }
                } else {
                    await this.createEachRouteForMethods(partner, account_id, entityName, version, methods, timeStamp, action);
                    resolve('success');
                }
            }, error => {
                resolve('success');
            });

        });
    }

    createServiceInGateway(serviceData) {
        return new Promise((resolve, reject) => {
            this.createServiceToApiGateway(serviceData).subscribe(response => {
                resolve('success');
            }, error => {
                reject(error);
            });
        });
    }

    createRouteInGateway(serviceData, route, entity) {
        let publishMessage = false;
        if (entity.entityName && entity.version && entity.action && entity.timeStamp){
            publishMessage = true;
        }
        return new Promise((resolve, reject) => {
            if (publishMessage) {
                this.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                    info: 'Deploying route for <b>' + route.methods[0] + '</b> method: ' +route.name,
                    type: 'initial',
                    icon: 'fa fa-shield'
                }, entity.timeStamp, entity.action);
            }
            this.createRouteForAServiceToApiGateway(serviceData['name'], route).subscribe(response => {
                if (publishMessage) {
                    this.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                        info: 'Deploying route for <b>' + route.methods[0] + '</b> method: ' +route.name,
                        type: 'success',
                        icon: 'fa fa-shield'
                    }, entity.timeStamp, entity.action);
                }
                resolve('success');
            }, error => {
                if (publishMessage) {
                    this.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                        info: 'Deploying route for <b>' + route.methods[0] + '</b> method: ' +route.name,
                        type: 'error',
                        icon: 'fa fa-shield'
                    }, entity.timeStamp, entity.action);
                }
                reject(error);
            });
        });
    }

    createPluginForServiceInGateway(serviceData, plugin, entity) {
        let publishMessage = false;
        if (entity.entityName && entity.version && entity.action && entity.timeStamp){
            publishMessage = true;
        }

        return new Promise((resolve, reject) => {
            if (publishMessage) {
                this.publishEventMessage(entity.entityName, entity.version, 'API GATEWAY MANAGEMENT', {
                    info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> policy for service',
                    type: 'initial',
                    icon: 'fa fa-shield'
                }, entity.timeStamp, entity.action);
            }
            this.createPluginForServiceInApiGateway(serviceData['name'], plugin).subscribe(response => {
                if (publishMessage) {
                    this.publishEventMessage(entity.entityName, entity.version, 'API GATEWAY MANAGEMENT', {
                        info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> policy for service',
                        type: 'success',
                        icon: 'fa fa-shield'
                    }, entity.timeStamp, entity.action);
                }
                resolve('success');
            }, error => {
                if (publishMessage) {
                    this.publishEventMessage(entity.entityName, entity.version, 'API GATEWAY MANAGEMENT', {
                        info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> policy for service',
                        type: 'error',
                        icon: 'fa fa-shield'
                    }, entity.timeStamp, entity.action);
                }
                reject('failed');
            });
        });
    }

    createPluginForRouteInGateway(route, plugin, entity) {

        let publishMessage = false;
        if (entity.entityName && entity.version && entity.action && entity.timeStamp){
            publishMessage = true;
        }


        return new Promise((resolve, reject) => {
            if (publishMessage) {
                this.publishEventMessage(entity.entityName, entity.version, 'API GATEWAY MANAGEMENT', {
                    info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> to route for <b>' + route.methods[0] + '</b> method',
                    type: 'initial',
                    icon: 'fa fa-shield'
                }, entity.timeStamp, entity.action);
            }
            this.createPluginForRouteInApiGateway(route['name'], plugin).subscribe(response => {
                if (publishMessage) {
                    this.publishEventMessage(entity.entityName, entity.version, 'API GATEWAY MANAGEMENT', {
                        info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> to route for <b>' + route.methods[0] + '</b> method',
                        type: 'success',
                        icon: 'fa fa-shield'
                    }, entity.timeStamp, entity.action);
                }
                resolve('success');
            }, error => {
                if (publishMessage) {
                    this.publishEventMessage(entity.entityName, entity.version, 'API GATEWAY MANAGEMENT', {
                        info: 'Configuring <b>' + (plugin['name'].charAt(0).toUpperCase() + plugin['name'].slice(1)).replace('-', ' ') + '</b> to route for <b>' + route.methods[0] + '</b> method',
                        type: 'error',
                        icon: 'fa fa-shield'
                    }, entity.timeStamp, entity.action);
                }
                reject(error);
            });
        });
    }

    configureAPIGatewayWithMethods(serviceData, routeDataParam, gatewayConfigurations, entity) {
        let publishMessage = false;
        if (entity.entityName && entity.version && entity.action && entity.timeStamp) {
            publishMessage = true;
        }
        let routeData = [];
        if (routeDataParam && routeDataParam.data) {
            routeData = routeDataParam.data;
            // routeData.forEach(route => {
            //     if (route && route !== null && route !== undefined && route.methods) {
            //         route.methods.push('OPTIONS');
            //     }
            // });
        }
        return new Promise(async (resolve, reject) => {
            if (gatewayConfigurations && gatewayConfigurations !== null && gatewayConfigurations !== undefined && gatewayConfigurations.length > 0) {
                if (publishMessage) {
                    this.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                        info: 'Deploying gateway configurations for the service',
                        type: 'initial',
                        icon: 'fa fa-cloud-upload'
                    }, entity.timeStamp, entity.action);
                }
                await this.createServiceInGateway(serviceData).then(async response1 => {
                    if (publishMessage) {
                        this.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                            info: 'Deploying gateway configurations for the service',
                            type: 'success',
                            icon: 'fa fa-cloud-upload'
                        }, entity.timeStamp, entity.action);
                    }
                    for (let j = 0; j < gatewayConfigurations.length; j++) {
                        if (gatewayConfigurations[j] && gatewayConfigurations[j] !== null && gatewayConfigurations[j] !== undefined) {
                            await this.createPluginForServiceInGateway(serviceData, gatewayConfigurations[j], entity).then(async response => {
                                if (j === gatewayConfigurations.length - 1) {
                                    if (routeData && routeData.length > 0) {
                                        for (let i = 0; i < routeData.length; i++) {
                                            if (routeData[i]) {
                                                await this.createRouteInGateway(serviceData, routeData[i], entity).then(async response2 => {
                                                    // if (i === routeData.length - 1) {
                                                    if (gatewayConfigurations && gatewayConfigurations !== null && gatewayConfigurations !== undefined && gatewayConfigurations.length > 0) {
                                                        for (let k = 0; k < gatewayConfigurations.length; k++) {
                                                            if (gatewayConfigurations[k] && gatewayConfigurations[k] !== null && gatewayConfigurations[k] !== undefined) {
                                                                await this.createPluginForRouteInGateway(routeData[i], gatewayConfigurations[k], entity).then(response3 => {
                                                                    if (i === routeData.length - 1 && k === gatewayConfigurations.length - 1) {
                                                                        resolve('success');
                                                                    }
                                                                }, error => {
                                                                    resolve('failed');
                                                                });
                                                            }
                                                        }
                                                    }
                                                    // }
                                                }, error => {
                                                    resolve('failed');
                                                });
                                            }
                                        }
                                    } else {
                                        resolve('success');
                                    }
                                }
                            }, error => {
                                resolve('failed');
                            });
                        }
                    }
                }, error => {
                    if (publishMessage) {
                        this.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                            info: 'Deploying gateway configurations for the service',
                            type: 'error',
                            description: 'Error while deploying gateway configurations for the service',
                            icon: 'fa fa-cloud-upload'
                        }, entity.timeStamp, entity.action);
                    }
                    reject(error);
                });
            } else {
                this.createServiceInGateway(serviceData).then(async response1 => {
                    if (routeData && routeData !== null && routeData !== undefined && routeData.length > 0) {
                        for (let i = 0; i < routeData.length; i++) {
                            if (routeData[i]) {
                                await this.createRouteInGateway(serviceData, routeData[i], entity).then(async response2 => {
                                    if (i === routeData.length - 1) {
                                        resolve('success');
                                    }
                                }, error => {
                                    resolve('failed');
                                });
                            } else {
                                resolve('success');
                            }
                        }
                    } else {
                        resolve('success');
                    }
                }, error => {
                    reject(error);
                });
            }
        });
    }

    // configureApiGatewayWithIpRestrictionWithMethods(partner, account_id, entityName, version, ipRestriction, isExecutor, methods) {
    //     return new Promise((resolve, reject) => {
    //         if (methods === null || methods === [] || methods === undefined) {
    //             methods = ['GET', 'PUT', 'POST', 'DELETE', 'PATCH'];
    //         }
    //         methods.push('OPTIONS');
    //         // this.gatewayUrl = (partner === account ? 'gateway.' + partner + '.apiplatform.io' : 'gateway.' + partner + '.' + account + '.apiplatform.io');
    //         this.gatewayUrl = (partner === account_id ? partner + '.gateway.apiplatform.io' : partner + '.' + account_id + '.gateway.apiplatform.io');
    //         this.gatewayFullUrl = 'https://' + this.gatewayUrl;
    //         this.routehostdata = {
    //             'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'host',
    //             'protocols': ['http', 'https'],
    //             'hosts': [this.gatewayUrl],
    //             // 'hosts': [this.partner + '-' + this.account + '-' + this.entityName + '-host'],
    //         };
    //         this.routepathdata = {
    //             'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'path',
    //             'protocols': ['http', 'https'],
    //             'hosts': [this.gatewayUrl],
    //             'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName],
    //             'methods': methods
    //         };
    //         this.ratelimitingOrig = {
    //             'name': 'rate-limiting',
    //             'config': {'minute': 5},
    //             'protocols': ['http', 'https'],
    //             'enabled': true
    //         };
    //
    //         this.keyauthOrig = {
    //             'name': 'key-auth'
    //         };
    //         this.ipRestriction = {
    //             'name': 'ip-restriction',
    //             'enabled': ipRestriction,
    //             'config': {
    //                 'whitelist': ['127.0.0.1']
    //             }
    //         };
    //         this.cors = {
    //             'name': 'cors',
    //             'enabled': true,
    //             'config': {
    //                 'methods': ['GET', 'PUT', 'POST', 'PATCH', 'DELETE', 'OPTIONS'],
    //                 'exposed_headers': [],
    //                 'max_age': 300,
    //                 'headers': [],
    //                 'origins': [
    //                     '*'
    //                 ],
    //                 'credentials': false,
    //                 'preflight_continue': false
    //             }
    //         };
    //         var url = '/' + ((typeof version) === 'object' ? version['name'] : version) + '/data/' + partner + '/' + account_id + '/' + entityName;
    //         if (isExecutor) {
    //             url = '/' + partner + '/' + account_id + '/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName;
    //         }
    //         this.servicedata = {
    //             'name': partner + '-' + account_id + '-' + entityName + '-' + version,
    //             'retries': 5,
    //             'protocol': 'https',
    //             'host': environment.apihostname,
    //             'port': 443,
    //             'path': url,
    //             'connect_timeout': 60000,
    //             'write_timeout': 60000,
    //             'read_timeout': 60000
    //         };
    //         this.createServiceToApiGateway(this.servicedata).subscribe(res => {
    //             this.createRouteForAServiceToApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.routepathdata).subscribe(route => {
    //                 this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ratelimitingOrig).subscribe(ratelimitingplugin => {
    //                     this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.keyauthOrig).subscribe(keyauthplugin => {
    //                         this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.cors).subscribe(serviceCORS => {
    //                             this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ipRestriction).subscribe(IPRestriction => {
    //                                 this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.ipRestriction).subscribe(iprestriction => {
    //                                     this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.ratelimitingOrig).subscribe(ratelimiting1 => {
    //                                         this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.keyauthOrig).subscribe(keyauth1 => {
    //                                             this.createPluginForRouteInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version + '-path', this.cors).subscribe(cors => {
    //                                                 resolve('success');
    //                                             });
    //                                         });
    //                                     });
    //                                 });
    //                             });
    //                         });
    //                     });
    //                 });
    //             });
    //         });
    //     });
    // }


    configureApiGatewayWithIpRestrictionWithMethods(partner, account_id, entityName, version, ipRestriction, isExecutor, methods, logTimeStamp, action, serviceObject = {applyCustom: false}) {
        return new Promise(async (resolve, reject) => {
            if (methods === null || methods === [] || methods === undefined) {
                methods = ['GET', 'PUT', 'POST', 'DELETE', 'PATCH'];
            }
            methods.push('OPTIONS');
            let title = '';
            if (action === 'redeploy') {
                title = 'API REDEPLOYMENT';
            } else {
                title = 'API DEPLOYMENT';
            }
            // this.gatewayUrl = (partner === account ? 'gateway.' + partner + '.apiplatform.io' : 'gateway.' + partner + '.' + account + '.apiplatform.io');
            this.gatewayUrl = await this.getTargetPartnerDefaultGatewayURL(partner, account_id, false);
            this.gatewayFullUrl = 'https://' + this.gatewayUrl;
            this.routehostdata = {
                'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'host',
                'protocols': ['http', 'https'],
                'hosts': [this.gatewayUrl],
                // 'hosts': [this.partner + '-' + this.account + '-' + this.entityName + '-host'],
            };
            // this.routepathdata = {
            //     'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + 'path',
            //     'protocols': ['http', 'https'],
            //     'hosts': [this.gatewayUrl],
            //     'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName],
            //     'methods': methods
            // };
            //
            // this.publishEventMessage(entityName, version, 'API DEPLOYMENT', {
            //     info: 'Collecting default gateway settings from your account',
            //     type: 'initial',
            //     icon: 'fa fa-cloud-upload'
            // }, logTimeStamp, 'deploy');
            this.getDefaultPlugins();
            // this.publishEventMessage(entityName, version, 'API DEPLOYMENT', {
            //     info: 'Collecting default gateway settings from your account',
            //     type: 'success',
            //     icon: 'fa fa-cloud-upload'
            // }, logTimeStamp, 'deploy');
            var url = '/' + ((typeof version) === 'object' ? version['name'] : version) + '/data/' + partner + '/' + account_id + '/' + entityName;
            if (isExecutor) {
                url = '/' + partner + '/' + account_id + '/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName;
            }
            if (!serviceObject.applyCustom) {
                this.servicedata = {
                    'name': partner + '-' + account_id + '-' + entityName + '-' + version,
                    'retries': 5,
                    'protocol': 'https',
                    'host': environment.apihostname,
                    'port': 443,
                    'path': url,
                    'connect_timeout': 60000,
                    'write_timeout': 60000,
                    'read_timeout': 60000
                };
            } else {
                // service name cannot be changed since it follows a standard
                this.servicedata = {
                    'name': partner + '-' + account_id + '-' + entityName + '-' + version,
                    'retries': serviceObject['retries'],
                    'protocol': serviceObject['protocol'],
                    'host': serviceObject['host'],
                    'port': serviceObject['port'],
                    'path': serviceObject['path'],
                    'connect_timeout': serviceObject['connect_timeout'],
                    'write_timeout': serviceObject['write_timeout'],
                    'read_timeout': serviceObject['read_timeout']
                };
            }
            this.publishEventMessage(entityName, version, title, {
                info: 'Deploying gateway configurations for the service',
                type: 'initial',
                icon: 'fa fa-cloud-upload'
            }, logTimeStamp, action);
            this.createServiceToApiGateway(this.servicedata).subscribe(async res => {
                this.publishEventMessage(entityName, version, title, {
                    info: 'Deploying gateway configurations for the service',
                    type: 'success',
                    icon: 'fa fa-cloud-upload'
                }, logTimeStamp, action);
                // this.createRouteForAServiceToApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.routepathdata).subscribe(route => {
                await this.createEachRouteForMethods(partner, account_id, entityName, version, methods, logTimeStamp, action);
                this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                    info: 'Configuring <b>Rate limiting</b> policy for the service',
                    type: 'initial',
                    icon: 'fa fa-shield'
                }, logTimeStamp, action);
                this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ratelimitingOrig).subscribe(ratelimitingplugin => {
                    this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                        info: 'Configuring <b>Rate limiting</b> policy for the service',
                        type: 'success',
                        icon: 'fa fa-shield'
                    }, logTimeStamp, action);
                    this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                        info: 'Configuring <b>Key auth</b> for the service',
                        type: 'initial',
                        icon: 'fa fa-shield'
                    }, logTimeStamp, action);
                    this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.keyauthOrig).subscribe(keyauthplugin => {
                        this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                            info: 'Configuring <b>Key auth</b> for the service',
                            type: 'success',
                            icon: 'fa fa-shield'
                        }, logTimeStamp, action);
                        this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                            info: 'Configuring <b>Ip restriction</b> policy for the service',
                            type: 'initial',
                            icon: 'fa fa-shield'
                        }, logTimeStamp, action);
                        this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.ipRestriction).subscribe(iprestriction => {
                            this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                info: 'Configuring <b>Ip restriction</b> policy for the service',
                                type: 'success',
                                icon: 'fa fa-shield'
                            }, logTimeStamp, action);
                            this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                info: 'Configuring <b>Cors</b> for the service',
                                type: 'initial',
                                icon: 'fa fa-shield'
                            }, logTimeStamp, action);
                            this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.cors).subscribe(cors => {
                                this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                    info: 'Configuring <b>Cors</b> for the service',
                                    type: 'success',
                                    icon: 'fa fa-shield'
                                }, logTimeStamp, action);
                                this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                    info: 'Configuring <b>Acl</b> policy for the service',
                                    type: 'initial',
                                    icon: 'fa fa-shield'
                                }, logTimeStamp, action);
                                this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.acl).subscribe(acl => {
                                    this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                        info: 'Configuring <b>Acl</b> policy for the service',
                                        type: 'success',
                                        icon: 'fa fa-shield'
                                    }, logTimeStamp, action);
                                    this.createPluginForServiceInApiGateway(partner + '-' + account_id + '-' + entityName + '-' + version, this.datadog).subscribe(acl => {
                                        resolve('success');
                                    }, error => {
                                    });
                                }, error => {
                                    this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                        info: 'Configuring <b>Acl</b> policy for the service',
                                        type: 'error',
                                        description: {},
                                        executor_method_type: 'POST',
                                        executor_type: '',
                                        authorization : {},
                                        queryParameters: [],
                                        pathParameters: [],
                                        url: environment.kongadminhost + '/services/' + partner + '-' + account_id + '-' + entityName + '-' + version + '/plugins',
                                        headers: { },
                                        request_body: this.acl
                                    }, logTimeStamp, action);
                                });
                            }, error => {
                                this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                    info: 'Configuring <b>Cors</b> for the service',
                                    type: 'error',
                                    description: {},
                                    executor_method_type: 'POST',
                                    executor_type: '',
                                    authorization : {},
                                    queryParameters: [],
                                    pathParameters: [],
                                    url: environment.kongadminhost + '/services/' + partner + '-' + account_id + '-' + entityName + '-' + version + '/plugins',
                                    headers: { },
                                    request_body: this.cors
                                }, logTimeStamp, action);
                            });
                        }, error => {
                            this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                                info: 'Configuring <b>Ip restriction</b> policy for the service',
                                type: 'error',
                                description: {},
                                executor_method_type: 'POST',
                                executor_type: '',
                                authorization : {},
                                queryParameters: [],
                                pathParameters: [],
                                url: environment.kongadminhost + '/services/' + partner + '-' + account_id + '-' + entityName + '-' + version + '/plugins',
                                headers: { },
                                request_body: this.ipRestriction
                            }, logTimeStamp, action);
                        });
                    }, error => {
                        this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                            info: 'Configuring <b>Key auth</b> for the service',
                            type: 'error',
                            description: {},
                            executor_method_type: 'POST',
                            executor_type: '',
                            authorization : {},
                            queryParameters: [],
                            pathParameters: [],
                            url: environment.kongadminhost + '/services/' + partner + '-' + account_id + '-' + entityName + '-' + version + '/plugins',
                            headers: { },
                            request_body: this.keyauthOrig
                        }, logTimeStamp, action);
                    });
                }, error => {
                    this.publishEventMessage(entityName, version, 'API GATEWAY MANAGEMENT', {
                        info: 'Configuring <b>Rate limiting</b> policy for the service',
                        type: 'error',
                        description: {},
                        executor_method_type: 'POST',
                        executor_type: '',
                        authorization : {},
                        queryParameters: [],
                        pathParameters: [],
                        url: environment.kongadminhost + '/services/' + partner + '-' + account_id + '-' + entityName + '-' + version + '/plugins',
                        headers: { },
                        request_body: this.ratelimitingOrig
                    }, logTimeStamp, action);
                });
                // });
            }, error => {
                this.publishEventMessage(entityName, version, title, {
                    info: 'Deploying gateway configurations for the service',
                    type: 'error',
                    icon: 'fa fa-cloud-upload'
                }, logTimeStamp, action);
            });

        });
    }

    createEachRouteForMethods(partner, account_id, entityName, version, methods, logTimeStamp, action) {
        return new Promise(async (resolve, reject) => {
            this.getDefaultPlugins();
            if (!methods.length) {
                resolve('success');
            } else {
                for (let i = 0; i < methods.length; i++) {
                    const method = methods[i];
                    if (method && method !== '') {
                        const routepathdata = {
                            'name': partner + '-' + account_id + '-' + entityName + '-' + version + '-' + method,
                            'protocols': ['http', 'https'],
                            'hosts': [this.gatewayUrl],
                            'paths': ['/' + ((typeof version) === 'object' ? version['name'] : version) + '/' + entityName],
                            'methods': [method]
                        };

                        if (method === 'OPTIONS') {
                            if (methods.includes('POST') === false) {
                                if (routepathdata.methods.includes('POST') === false) {
                                    routepathdata.methods.push('POST');
                                }
                            }
                        }

                        await this.createRouteForService(partner, account_id, entityName, version, routepathdata, logTimeStamp, action);
                        const pluginsToBeConfigured = [this.ratelimitingOrig, this.keyauthOrig, this.cors, this.ipRestriction, this.acl, this.datadog];

                        for (let j = 0; j < pluginsToBeConfigured.length; j++) {
                            const plugin = pluginsToBeConfigured[j];
                            if (plugin) {
                                await this.createPluginForRoute(partner, account_id, entityName, version, method, plugin, logTimeStamp, action);
                                if (i === methods.length - 1 && j === pluginsToBeConfigured.length -1) {
                                    resolve('success');
                                }
                            }
                        }
                    }
                }
            }
        });
    }

    removePluginsFromRoute(route) {
        return new Promise((resolve, reject) => {
            let status = '';
            let i = 0;
            this.getPluginsForRouteInApiGateway(route['id']).subscribe(routePluginRes => {
                if (routePluginRes && routePluginRes !== null && routePluginRes !== undefined && routePluginRes['data'] && routePluginRes['data'].length > 0) {
                    routePluginRes['data'].forEach(routePlugin => {
                        this.deletePluginFromApiGateway(routePlugin['id']).subscribe(response => {
                            i = i + 1;
                            if (i === routePluginRes['data'].length) {
                                status = 'success';
                                resolve('success');
                            }
                        }, error => {
                            reject(error);
                        });
                    });
                } else {
                    resolve('success');
                }
            }, error => {
                reject(error);
            });
        });
    }

    deleteRoutesInApiGatewayConfigForApi(partner, account, pkey, deleteGatewayConfig, entity, version) {
        return new Promise((resolve, reject) => {
            if (deleteGatewayConfig) {
                this.getRoutesForAServiceFromApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(routes => {
                    this.gatewayRoutes = routes;
                    let routesCount = 0;
                    this.routes = this.gatewayRoutes.data;
                    if (this.routes && this.routes !== null && this.routes !== undefined && this.routes.length > 0) {
                        this.routes.forEach(route => {
                            Promise.resolve(this.removePluginsFromRoute(route)).then(response => {
                                this.deleteRouteFromApiGatewayByNameOrId(route['id']).subscribe(resp => {
                                    routesCount += 1;
                                    if (routesCount === this.routes.length) {
                                        resolve('success');
                                    }
                                }, error => {
                                    reject(error);
                                });
                            }, error => {
                                reject(error);
                            });
                        });
                    } else {
                        resolve('success');
                    }
                }, error => {
                    reject(error);
                });
            } else {
                resolve('success');
            }
        });

        // this.kong.deletePluginFromApiGateway(this.rateLimitingId).subscribe(ratelimitingplugin => {
        //     this.kong.deletePluginFromApiGateway(this.keyAuthId).subscribe(keyauthplugin => {
        //         this.kong.deletePluginFromApiGateway(this.pathRouteRateLimitingPluginId).subscribe(rate1 => {
        //             // this.kong.deletePluginFromApiGateway(this.hostRouteRateLimitingPluginId).subscribe(r2 => {
        //             this.kong.deletePluginFromApiGateway(this.pathRouteKeyAuthPluginId).subscribe(ke1 => {
        //                 // this.kong.deletePluginFromApiGateway(this.hostRouteKeyAuthPluginId).subscribe(k2 => {
        //                 this.kong.deleteRouteFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + entity + +'-' + version + '-path').subscribe(route => {
        //                     // this.kong.deleteRouteFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + entity + '-host').subscribe(route1 => {
        //                     this.kong.deleteServiceFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + entity + '-' + version).subscribe(res => {
        //                     });
        //                 });
        //             });
        //             // });
        //             // });
        //             // });
        //         });
        //     });
        // });
    }

    // Services Management
    createServiceToApiGateway(data) {
        return this._http.post(environment.kongadminhost + '/services', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    getServicesFromApiGateway() {
        return this._http.get(environment.kongadminhost + '/services', this.httpOptions)
            .pipe(map(res => res));
    }

    getServicesFromApiGatewayByNameOrId(service) {
        return this._http.get(environment.kongadminhost + '/services/' + service, this.httpOptions)
            .pipe(map(res => res));
    }

    getServicesForRouteFromApiGatewayByNameOrId(route, service) {
        return this._http.get(environment.kongadminhost + '/routes/' + route + '/' + service, this.httpOptions)
            .pipe(map(res => res));
    }

    getServicesForPluginFromApiGatewayByNameOrId(plugin, service) {
        return this._http.get(environment.kongadminhost + '/plugins/' + plugin + '/' + service, this.httpOptions)
            .pipe(map(res => res));
    }

    updateServiceInApiGateway(service, data) {
        return this._http.patch(environment.kongadminhost + '/services/' + service, data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateServiceForRouteInApiGateway(route, service, data) {
        return this._http.put(environment.kongadminhost + '/routes/' + route + '/' + service, data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateServiceForPluginInApiGateway(plugin, service, data) {
        return this._http.put(environment.kongadminhost + '/plugins/' + plugin + '/' + service, data, this.httpOptions)
            .pipe(map(res => res));
    }

    deleteServiceFromApiGatewayByNameOrId(service) {
        return this._http.delete(environment.kongadminhost + '/services/' + service, this.httpOptions)
            .pipe(map(res => res));
    }

    deleteServiceForRouteFromApiGatewayByNameOrId(route, service) {
        return this._http.delete(environment.kongadminhost + '/routes/' + route + '/' + service, this.httpOptions)
            .pipe(map(res => res));
    }

    // Routes Management

    createRouteInApiGateway(data) {
        return this._http.post(environment.kongadminhost + '/routes', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Route Associated to a Specific Service
    createRouteForAServiceToApiGateway(service, data) {
        return this._http.post(environment.kongadminhost + '/services/' + service + '/routes', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // List All Routes
    getRoutesFromApiGateway() {
        return this._http.get(environment.kongadminhost + '/routes', this.httpOptions)
            .pipe(map(res => res));
    }

    // List Routes Associated to a Specific Service
    getRoutesForAServiceFromApiGateway(service) {
        return this._http.get(environment.kongadminhost + '/services/' + service + '/routes', this.httpOptions)
            .pipe(map(res => res));
    }

    // Retrieve Route
    getRouteFromApiGatewayByNameOrId(route) {
        return this._http.get(environment.kongadminhost + '/routes/' + route, this.httpOptions)
            .pipe(map(res => res));
    }

    // Retrieve Route Associated to a Specific Plugin
    getRoutesForPluginFromApiGatewayByNameOrId(plugin) {
        return this._http.get(environment.kongadminhost + '/plugins/' + plugin + '/route', this.httpOptions)
            .pipe(map(res => res));
    }

    // Update Route
    updateRouteInApiGateway(route, data) {
        return this._http.put(environment.kongadminhost + '/routes/' + route, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    patchRouteInApiGateway(route, data) {
        return this._http.patch(environment.kongadminhost + '/routes/' + route, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // PermalinkUpdate Route Associated to a Specific Plugin
    updateRouteForPluginInApiGateway(plugin, data) {
        return this._http.put(environment.kongadminhost + '/plugins/' + plugin + '/route', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Route
    deleteRouteFromApiGatewayByNameOrId(route) {
        return this._http.delete(environment.kongadminhost + '/routes/' + route, this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Consumer
    createConsumerInApiGateway(data) {
        return this._http.post(environment.kongadminhost + '/consumers', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    createConsumerInNewApiGateway(data) {
        return this._http.post(environment.kongnewadminhost + '/consumers', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // getConsumersInNewApiGatewayByNameOrId(consumer) {
    //     return this._http.get(environment.kongnewadminhost + '/consumers/' + consumer, this.httpOptions)
    //         .pipe(map(res => res));
    // }

    // Create JWT Token for Consumer
    createJwtForConsumerInApiGateway(consumer) {
        return this._http.post(environment.kongadminhost + '/consumers/' + consumer + '/jwt', this.httpOptions)
            .pipe(map(res => res));
    }

    // Get Consumers
    getConsumersInApiGateway() {
        return this._http.get(environment.kongadminhost + '/consumers', this.httpOptions)
            .pipe(map(res => res));
    }

    // Get Consumers
    getConsumersInApiGatewayByNameOrId(consumer) {
        return this._http.get(environment.kongadminhost + '/consumers/' + consumer, this.httpOptions)
            .pipe(map(res => res));
    }

    provisionKeyAuthToConsumerInApiGatewayByNameOrId(consumer, data) {
        return this._http.post(environment.kongadminhost + '/consumers/' + consumer + '/key-auth', data, this.httpOptions)
            .pipe(map(res => res));
    }

    provisionKeyAuthToConsumerInNewApiGatewayByNameOrId(consumer, data) {
        return this._http.post(environment.kongnewadminhost + '/consumers/' + consumer + '/key-auth', data, this.httpOptions)
            .pipe(map(res => res));
    }

    getKeyAuthForConsumerInApiGatewayByNameOrId(consumer) {
        return this._http.get(environment.kongadminhost + '/consumers/' + consumer + '/key-auth', this.httpOptions)
            .pipe(map(res => res));
    }

    // Retrieve Consumer Associated to a Specific Plugin
    // Get Consumers
    getConsumersForPluginInApiGateway(plugin) {
        return this._http.get(environment.kongadminhost + '/plugins/' + plugin + '/consumer', this.httpOptions)
            .pipe(map(res => res));
    }

    // Update Consumer
    updateConsumerInApiGateway(consumer, data) {
        return this._http.put(environment.kongadminhost + '/consumers/' + consumer, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Or Update Consumer Associated to a Specific Plugin
    updateConsumerForPluginInApiGateway(plugin, data) {
        return this._http.put(environment.kongadminhost + '/plugins/' + plugin + '/consumer', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Consumer
    deleteConsumerFromApiGateway(consumer) {
        return this._http.delete(environment.kongadminhost + '/consumers/' + consumer, this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Plugin
    createPluginInApiGateway(data) {
        return this._http.post(environment.kongadminhost + '/plugins', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Plugin Associated to a Specific Route
    createPluginForRouteInApiGateway(route, data) {
        return this._http.post(environment.kongadminhost + '/routes/' + route + '/plugins', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Plugin Associated to a Specific Service
    createPluginForServiceInApiGateway(service, data) {

        return this._http.post(environment.kongadminhost + '/services/' + service + '/plugins', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Plugin Associated to a Specific Consumer
    createPluginForConsumerInApiGateway(consumer, data) {
        return this._http.post(environment.kongadminhost + '/consumers/' + consumer + '/plugins', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Get Plugins
    getPluginsInApiGateway() {
        return this._http.get(environment.kongadminhost + '/plugins', this.httpOptions)
            .pipe(map(res => res));
    }

    // Retrieve a Specific Plugin
    getPluginsInApiGatewayByNameOrId(plugin) {
        return this._http.get(environment.kongadminhost + '/plugins/' + plugin, this.httpOptions)
            .pipe(map(res => res));
    }

    // List Plugins Associated to a Specific Route
    getPluginsForRouteInApiGateway(route) {
        return this._http.get(environment.kongadminhost + '/routes/' + route + '/plugins', this.httpOptions)
            .pipe(map(res => res));
    }

    // List Plugins Associated to a Specific Service
    getPluginsForServiceInApiGateway(service) {
        return this._http.get(environment.kongadminhost + '/services/' + service + '/plugins', this.httpOptions)
            .pipe(map(res => res));
    }

    getPluginsForServiceByPluginNameInApiGateway(service, pluginName) {
        let plugins;
        return this._http.get(environment.kongadminhost + '/services/' + service + '/plugins', this.httpOptions)
            .pipe(map(res => {
                plugins = res;
                for (const plugin of plugins['data']) {
                    if (plugin['name'] === pluginName) {
                        return plugin;
                    }
                }
            }));
    }

    getPluginsForRouteByPluginNameInApiGateway(route, pluginName) {
        let plugins;
        return this._http.get(environment.kongadminhost + '/routes/' + route + '/plugins', this.httpOptions)
            .pipe(map(res => {
                plugins = res;
                for (const plugin of plugins['data']) {
                    if (plugin['name'] === pluginName) {
                        return plugin;
                    }
                }
            }));
    }

    // List Plugins Associated to a Specific Consumer
    getPluginsForConsumerInApiGateway(consumer) {
        return this._http.get(environment.kongadminhost + '/consumers/' + consumer + '/plugins', this.httpOptions)
            .pipe(map(res => res));
    }

    // Update Plugin
    updatePluginInApiGateway(plugin, data) {
        return this._http.put(environment.kongadminhost + '/plugins/' + plugin, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Update Plugin
    patchPluginInApiGateway(plugin, data) {

        return this._http.patch(environment.kongadminhost + '/plugins/' + plugin, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));

    }

    patchPluginForRouteInApiGateway(route, plugin, data) {
        return this._http.patch(environment.kongadminhost + '/routes/' + route + '/plugins/' + plugin, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Plugin
    deletePluginFromApiGateway(plugin) {
        return this._http.delete(environment.kongadminhost + '/plugins/' + plugin, this.httpOptions)
            .pipe(map(res => res));
    }

    // Retrieve Enabled Plugins
    getEnabledPluginsInApiGateway(plugin) {
        return this._http.get(environment.kongadminhost + '/plugins/enabled', this.httpOptions)
            .pipe(map(res => res));
    }

    // Retrieve Plugin Schema
    getPluginSchemaInApiGateway(plugin) {
        return this._http.get(environment.kongadminhost + '/plugins/schema/' + plugin, this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Certificate
    createCertificateInApiGateway(data) {
        return this._http.post(environment.kongadminhost + '/certificates', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // List All Certificates
    getCertificatesFromApiGateway() {
        return this._http.get(environment.kongadminhost + '/certificates', this.httpOptions)
            .pipe(map(res => res));
    }

    // Get Certificates
    getCertificatesInApiGatewayByNameOrId(certificate) {
        return this._http.get(environment.kongadminhost + '/certificates/' + certificate, this.httpOptions)
            .pipe(map(res => res));
    }

    // Update Certificate
    updateCertificateInApiGateway(certificate, data) {
        return this._http.put(environment.kongadminhost + '/certificates/' + certificate, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Certificate
    deleteCertificateFromApiGateway(certificate) {
        return this._http.delete(environment.kongadminhost + '/certificates/' + certificate, this.httpOptions)
            .pipe(map(res => res));
    }

    // Create SNIs
    createSniInApiGateway(data) {
        return this._http.post(environment.kongadminhost + '/snis', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Create SNI Associated to a Specific Certificate
    createSniForCertificateInApiGateway(certificate, data) {
        return this._http.post(environment.kongadminhost + '/certificates/' + certificate + '/snis', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // List All SNIs
    getSnisFromApiGateway() {
        return this._http.get(environment.kongadminhost + '/snis', this.httpOptions)
            .pipe(map(res => res));
    }

    // Get Sni by name or id
    getSniInApiGatewayByNameOrId(sni) {
        return this._http.get(environment.kongadminhost + '/snis/' + sni, this.httpOptions)
            .pipe(map(res => res));
    }

    // Update Sni
    updateSniInApiGateway(sni, data) {
        return this._http.put(environment.kongadminhost + '/snis/' + sni, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Sni
    deleteSniFromApiGateway(sni) {
        return this._http.delete(environment.kongadminhost + '/snis/' + sni, this.httpOptions)
            .pipe(map(res => res));
    }


    // Create Upstream
    createUpstreamInApiGateway(data) {
        return this._http.post(environment.kongadminhost + '/upstreams', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // List All Upstreams
    getUpstreamsFromApiGateway() {
        return this._http.get(environment.kongadminhost + '/upstreams', this.httpOptions)
            .pipe(map(res => res));
    }

    // Get Sni by name or id
    getUpstreamInApiGatewayByNameOrId(upstream) {
        return this._http.get(environment.kongadminhost + '/upstreams/' + upstream, this.httpOptions)
            .pipe(map(res => res));
    }

    // Retrieve Upstream Associated to a Specific Target
    getUpstreamsForTargetFromApiGateway(target) {
        return this._http.get(environment.kongadminhost + '/targets/' + target + '/upstream', this.httpOptions)
            .pipe(map(res => res));
    }

    // Update Upstreams
    updateUpstreamsInApiGateway(upstream, data) {
        return this._http.put(environment.kongadminhost + '/upstreams/' + upstream, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Or Update Upstream Associated to a Specific Target
    updateUpstreamForTargetFromApiGateway(target, data) {
        return this._http.put(environment.kongadminhost + '/targets/' + target + '/upstream', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Upstream
    deleteUpstreamFromApiGateway(upstream) {
        return this._http.delete(environment.kongadminhost + '/upstreams/' + upstream, this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Upstream Associated to a Specific Target
    deleteUpstreamForTargetFromApiGateway(target, upstream) {
        return this._http.delete(environment.kongadminhost + '/targets/' + target + '/upstream', this.httpOptions)
            .pipe(map(res => res));
    }

    // Show Upstream Health for Node
    getUpstreamHealthForTargetFromApiGateway(upstream) {
        return this._http.get(environment.kongadminhost + '/upstreams/' + upstream + '/health/', this.httpOptions)
            .pipe(map(res => res));
    }

    // Create Target Associated to a Specific Upstream
    createTargetForUpstreamInApiGateway(upstream, data) {
        return this._http.post(environment.kongadminhost + '/upstreams/' + upstream + '/targets', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // List Targets Associated to a Specific Upstream
    getTargetForUpstreamInApiGateway(upstream) {
        return this._http.get(environment.kongadminhost + '/upstreams/' + upstream + '/targets', this.httpOptions)
            .pipe(map(res => res));
    }

    // Delete Target
    deleteTargetFromApiGateway(target, upstream) {
        return this._http.delete(environment.kongadminhost + '/upstreams/' + upstream + '/targets/' + target, this.httpOptions)
            .pipe(map(res => res));
    }

    // Set Target As Healthy
    setTargetAsHealthyInApiGateway(target, upstream, data) {
        return this._http.post(environment.kongadminhost + '/upstreams/' + upstream + '/targets/' + target + '/healthy', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // Set Target As Healthy
    setTargetAsUnealthyInApiGateway(target, upstream, data) {
        return this._http.post(environment.kongadminhost + '/upstreams/' + upstream + '/targets/' + target + '/unhealthy', JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    // List All Targets
    getTargetsForUpstreamInApiGateway(upstream) {
        return this._http.get(environment.kongadminhost + '/upstreams/' + upstream + '/targets/all/', this.httpOptions)
            .pipe(map(res => res));
    }

    getKongGatewayConsumerDetails(partner) {

        return this._http.get(environment.kongadminhost + '/consumers?custom_id=' + partner)
            .pipe(map(res => res));

    }

    getAssignedKongConsmers(partner) {

        return this._http.get(environment.kongadminhost + '/consumers?tags=' + partner)
            .pipe(map(res => res));

    }

    getKongGatewayCredentialDetails(credentialType, id) {
        return this._http.get(environment.kongadminhost + '/consumers/' + id + '/' + credentialType)
            .pipe(map(res => res));
    }

    postKongGatewayAPIkeyDetails(id, payload, type) {
        return this._http.post(environment.kongadminhost + '/consumers/' + id + '/' + type, payload)
            .pipe(map(res => res));
    }

    postKongGatewayAPIkeyDetailsInNew(id, payload, type) {
        return this._http.post(environment.kongnewadminhost + '/consumers/' + id + '/' + type, payload)
            .pipe(map(res => res));
    }

    deleteKongGatewayConsumerCredential(user_id, type, id) {
        return this._http.delete(environment.kongadminhost + '/consumers/' + user_id + '/' + type + '/' + id)
            .pipe(map(res => res));
    }

    deletKongConsumer(id) {
        return this._http.delete(environment.kongadminhost + '/consumers/' + id)
            .pipe(map(res => res));
    }

    createConsumerToKong(payload) {
        return this._http.post(environment.kongadminhost + '/consumers/', payload)
            .pipe(map(res => res));
    }

    patchTagToConsumer(id, payload) {
        return this._http.patch(environment.kongadminhost + '/consumers/' + id, payload)
            .pipe(map(res => res));
    }

    getAllConsumers(offset) {
        let url = environment.kongadminhost + '/consumers';
        if (offset && offset !== '') {
            url = url + '?offset=' + offset;
        }
        return this._http.get(url).pipe(map(res => res));
    }

    getOAuth2Token(partner, account, APIName, version,  payload, apikey, gatewayURLHost) {
        const headers = new HttpHeaders({
            'apikey': apikey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post('https://' + gatewayURLHost + '/' + version + '/' + APIName + '/oauth2/token', payload, {headers: headers})
            .pipe(map(res => res));
    }
}
